import React, { FC, ReactNode } from 'react';

import { Button } from '@/Components/UI';
import { BrandProductPreviewResource } from '@/entities/Brand/api';
import { PreviewProduct } from '@/features/BrandActionConfirmModal/ui/BrandActionConfirmModal/components';

import { useBrandActionConfirmControl } from '../../model/useBrandActionConfirmControl';
import S from './BrandActionConfirmModal.module.scss';

interface BrandActionConfirmModalProps {
    brandId: number;

    title?: ReactNode;
    confirmBrandText?: ReactNode;
    confirmPartialText?: ReactNode;
    getPreviewProducts: (brandId: number) => Promise<BrandProductPreviewResource[]>;

    actionOnlyBrand: () => Promise<void>;
    actionBrandWithProducts: () => Promise<void>;
    close: () => void;
}

export const BrandActionConfirmModal: FC<BrandActionConfirmModalProps> = ({ title, confirmBrandText, confirmPartialText, ...props }) => {
    const brandActionControl = useBrandActionConfirmControl(props);

    return (
        <div className={S.root}>
            <h3 className={S.root__title}>{title}</h3>

            <p className={S.root__description}>Brand products:</p>

            <div className={S.preview_products}>
                {brandActionControl.previewProductsBrand.map((previewProduct) => (
                    <PreviewProduct key={previewProduct.id} previewProduct={previewProduct} />
                ))}
            </div>

            <div className={S.root__actions}>
                <Button disabled={brandActionControl.isLoading} onClick={brandActionControl.actionOnlyBrand}>
                    {confirmBrandText}
                </Button>
                <Button disabled={brandActionControl.isLoading} onClick={brandActionControl.actionBrandWithProducts}>
                    {confirmPartialText}
                </Button>
                <Button disabled={brandActionControl.isLoading} color={'brown'} onClick={props.close}>
                    Back
                </Button>
            </div>
        </div>
    );
};
